export default __webpack_public_path__ + "static/media/portfolio-07.fa110e65.jpg";